import { defineStore } from 'pinia';
import { ref, computed, watch } from "vue";
import { useQuery } from '@vue/apollo-composable'
import ME_QUERY from '@/graphql/User/MeQuery.gql'


export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('apollo-token') || null)
  const authUser = ref(null)
  const isAuthenticated = computed(() => !!token.value )
  const isImpersonating = ref(false);

  const { result, refetch: refetchMe, onResult } = useQuery(ME_QUERY)
  
  watch(token, (newToken) => {
    refetchMe();
  });

  onResult(({data})=>{
    if(data?.me){
      authUser.value = data.me
      localStorage.setItem('authUser', JSON.stringify(data.me))
    }
  })


  function addAuth(authToken, user = null, impersonation = false) {
    if(authToken == null)
    {
      localStorage.removeItem('apollo-token')
      localStorage.removeItem('authUser')
      token.value = null
      authUser.value = null
      isImpersonating.value = impersonation
    }

    if(user == null){

    }

    localStorage.setItem('apollo-token', authToken)
    token.value = authToken
    
  }

  function removeAuth(){
    localStorage.removeItem('apollo-token')
    localStorage.removeItem('authUser')
    token.value = null
    authUser.value = null
    isImpersonating.value = false
  }

  return { token, authUser, addAuth, removeAuth, isAuthenticated }
})